module.exports = __webpack_public_path__ + "img/51a2d94.svg";